export default function isScrolledDown() {
  return {
    scope: {
      isScrolledDown: '=',
      scrollToBottom: '=?',
    },
    link($scope, $element, $attrs) {
      if (!__TEST__ && 'scrollDownOnResize' in $attrs) {
        $scope.scrollToBottom = () => {
          $element[0].scrollTop = $element[0].scrollHeight - $element[0].clientHeight;
        };

        if (ResizeObserver) {
          const resizeObserver = new ResizeObserver(() => {
            if ($scope.isScrolledDown) {
              $scope.scrollToBottom();
            }
          });

          resizeObserver.observe($element[0]);
          $scope.$on('$destroy', () => {
            resizeObserver.disconnect();
          });
        }
      }

      $element.on('scroll', () => {
        $scope.$evalAsync(() => {
          $scope.isScrolledDown =
            $element[0].clientHeight + $element[0].scrollTop === $element[0].scrollHeight;
        });
      });
    },
  };
}
